import { render } from "./StallionsPage.vue?vue&type=template&id=c146ba44&scoped=true"
import script from "./StallionsPage.vue?vue&type=script&lang=js"
export * from "./StallionsPage.vue?vue&type=script&lang=js"

import "./StallionsPage.vue?vue&type=style&index=0&id=c146ba44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c146ba44"]])

export default __exports__